import defaultsDeep from 'lodash/defaultsDeep';

import defaultBg from './assets/backgrounds/HeroBackground-Option1-01.png';
import defaultBg2 from './assets/backgrounds/HeroBackground-Option2-01.png';
import defaultBg3 from './assets/backgrounds/HeroBackground-Option3-01.png';

import { LoginVariant } from './interfaces/login';

interface VariantMap {
  [id: string]: LoginVariant;
}

const defaults = {
  type: 'default',
  textColor: 'white',
  background: {
    image: defaultBg,
    horizontalPosition: 'center',
    verticalPosition: 'center',
    height: '180px',
    width: '360px'
  }
};

export const newBg2 = defaultsDeep(
  {
    type: 'newBg2',
    background: {
      image: defaultBg2
    }
  },
  defaults
);

export const newBg3 = defaultsDeep(
  {
    type: 'newBg3',
    background: {
      image: defaultBg3
    }
  },
  defaults
);

/* Example Variation: App Platform GA release (also see file imports above for background and logo)
export const appPlatformGitlab = defaultsDeep(
  {
    type: 'appPlatformGitlab',
    background: {
      image: doGitlabBg
    },
    image: gitlabLogo,
    title: 'DigitalOcean App Platform now integrates with GitLab!',
    subtitle:
      'Deploy code directly from GitLab repos. Just point App Platform to your repo and follow a few simple steps to launch your app.',
    button: {
      variation: 'success',
      text: 'Learn more',
      url:
        'https://www.digitalocean.com/blog/introducing-gitlab-integration-for-digitalocean-app-platform'
    }
  },
  defaults
); */

export const teamVariant = defaultsDeep(
  {
    type: 'team',
    title: 'Join your team on DigitalOcean!',
    subtitle:
      '{{name}} has invited you to join them. Sign in and start making waves with your team today!'
  },
  defaults
);

// These are for randomly choosing login variants
const loginVariants: VariantMap = {
  primary: defaults,
  newBg2,
  newBg3
};

export default loginVariants;
